export default __webpack_public_path__ + "static/media/Techsee_logo_blue.504a8c94.png";